import { Component } from 'react'
import Head from 'next/head'

import AppBar from 'Components/AppBar'
import Breadcrumb from 'Components/Breadcrumb'
import Footer from 'Components/Footer'

import cn from 'classnames'
import cg from 'Scss/app.scss'
import cl from 'Scss/pages/Index.scss'
import btn from 'Components/Button/Button.scss'
import appBar from 'Components/AppBar/AppBar.scss'

import plp from 'Components/ProductListPage/components/ProductListPageHeader/ProductListPageHeader.scss'

import PromotionBlock from 'Components/PromotionBlock';
import { PromotionPlace } from 'Utils/api/gql/types';
import { StickyContainerFix } from 'Components/StickyContainerFix';
import { connect, DispatchProp } from 'react-redux';
import CartPanel from 'Components/CartPanel';
import Button from 'Components/Button';
import { SVGArrowBack } from 'Components/SVGCollection';
import { toggleCart } from 'Utils/redux/actions';
import { formatBreadcrumbForGtm } from 'Components/Breadcrumb/Breadcrumb';

interface ReduxProps {
    isOpenedCartPanel: boolean
}

type Props = ReduxProps & DispatchProp

class PromotionPage extends Component<Props> {
    toggleBasketBar = () => {
        this.props.dispatch(toggleCart())
    }

    render() {
        const breadcrumbData = [
            {
                href: '/',
                title: 'Főoldal',
                gtmName: 'Home'
            },
            {
                href: '/termekvalogatasok',
                title: 'Termékválogatások',
                gtmName: 'Promotions'
            }
        ]

        return (
            <div>
                <Head>
                    <title>Ajánlott termékválogatások</title>
                </Head>
                <AppBar
                    pageType="List"
                    breadcrumb={formatBreadcrumbForGtm(breadcrumbData)}
                />
                <div className={cn(cg.contentHolder, cl.home)}>
                    <StickyContainerFix>

                        <div className={`${cg.gridContainer} ${cg.panelLayout} ${this.props.isOpenedCartPanel === true ? cg.opened : ''}`}>
                            <div className={cn(cg.cartOpener, appBar.cartOpener)}>
                                <Button
                                    label="Kosár tartalma"
                                    className={cn(btn.hollow)}
                                    disabled={false}
                                    renderIcon={{ alignIcon: null, ariaLabel: 'ariaLabel', Icon: <SVGArrowBack width={24} height={24} /> }}
                                    onClick={this.toggleBasketBar}
                                />
                            </div>

                            <CartPanel />

                            <div className={cn(cg.contentPanel, appBar.contentPanel, cl.contentPanel, cg.mediumOrder1, cg.opened)}>
                                <div className={cn(cg.gridContainer, cl.storesContainer)}>
                                    <div className={cn(cg.showForMedium, cl.breadcrumbContainer)}>
                                        <Breadcrumb data={breadcrumbData} />
                                    </div>
                                    <div className={cn(cg.gridX, plp.productListPage__header, cg.showForLarge)}>
                                        <div className={cn(cg.cell, cg.shrink)}>
                                            <a className={plp.linkBack} href="/">
                                                <span className={cg.showForSr}>
                                                    Vissza
                                                </span>

                                                <span aria-hidden="true">
                                                    <SVGArrowBack width="32" height="32" />
                                                </span>
                                            </a>
                                        </div>
                                        <div className={cn(cg.cell, cg.auto)}>
                                            <h1 className={cn(plp.h1)}>Ajánlott termékválogatások</h1>
                                        </div>
                                    </div>
                                    <PromotionBlock blockId={PromotionPlace.PROMO_1} type="fourColumn" />

                                    <PromotionBlock blockId={PromotionPlace.PROMO_2} type="fourColumn" />

                                    <PromotionBlock blockId={PromotionPlace.PROMO_3} type="fourColumn" />

                                    <PromotionBlock blockId={null} type="fourColumn" />

                                </div>
                            </div>
                        </div>
                    </StickyContainerFix>
                    <Footer />
                </div>
            </div>
        )
    }
}

function mapToStateProps({ isOpenedCartPanel }: Redux.IReduxState)  {
    return { isOpenedCartPanel }
}

export default connect(mapToStateProps)(PromotionPage)
